import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { DocumentModel } from "@insite/client-framework/Types/ApiModels";
import React, { useState } from "react";
import styled from "styled-components";

const ImagePreviewContainer = styled.div`
    display: flex;
    gap: 20px;
`;

const ThumbnailPane = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
`;

interface ThumbnailWrapperProps {
    isSelected: boolean;
}

const ThumbnailWrapper = styled.div<ThumbnailWrapperProps>`
    width: 40px;
    border: 1px solid ${themeBackgrounds.lightGray};
    overflow: hidden;
    cursor: pointer;
    transition: border-color 0.2s ease-in-out;
    border-color: ${props => (props.isSelected ? themeColors.primary.danaBlue : themeBackgrounds.lightGray)};
    opacity: ${props => (props.isSelected ? "1" : ".4")};
`;

interface ImgProps {
    src: string;
    altText: string;
    loading?: "eager" | "lazy";
    "data-test-selector"?: string;
    tabIndex?: number;
}

const Img = styled.img.attrs<ImgProps>(props => ({
    alt: props.altText,
}))<ImgProps>`
    width: 100%;
    height: 40px;
    object-fit: cover;
    display: block;
`;

const StyledWrapper = styled.div``;

const MainPreviewPane = styled.div`
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const MainImage = styled.img`
    max-width: 100%;
    height: auto;
    object-fit: contain;
    display: block;

    @media print {
        max-width: 350px;
    }
`;

interface ProductModelDiagramPreviewProps {
    documents: DocumentModel[];
    type: string;
}

const ProductModelDiagramPreview: React.FC<ProductModelDiagramPreviewProps> = ({ documents, type }) => {
    
    const imageDocuments = documents.filter(doc => doc.documentType?.toLowerCase() === type?.toLowerCase());

    const [selectedImageDocument, setSelectedImageDocument] = useState<DocumentModel | null>(
        imageDocuments.length > 0 ? imageDocuments[0] : null,
    );

    const handleThumbnailClick = (doc: DocumentModel) => {
        setSelectedImageDocument(doc);
    };

    return (
        <ImagePreviewContainer>
            <ThumbnailPane>
                {imageDocuments.map(doc => (
                    <ThumbnailWrapper
                        key={doc.id.toString()}
                        isSelected={selectedImageDocument?.id === doc.id}
                        onClick={() => handleThumbnailClick(doc)}
                    >
                        <StyledWrapper>
                            <Img
                                src={doc.filePath}
                                altText={doc.name}
                                loading="eager"
                                data-test-selector="productDetails_modelDiagram"
                                tabIndex={0}
                            />
                        </StyledWrapper>
                    </ThumbnailWrapper>
                ))}
            </ThumbnailPane>
            <MainPreviewPane>
                {selectedImageDocument ? (
                    <MainImage src={selectedImageDocument.filePath} alt={selectedImageDocument.name} />
                ) : (
                    ""
                )}
            </MainPreviewPane>
        </ImagePreviewContainer>
    );
};

export default ProductModelDiagramPreview;
